export default __webpack_public_path__ + "static/media/Skyshear Armbands.01c6f8b4.jpg";